import React from "react";
import CreateUserCard from "./UserCard";
import { CardTypes } from "./UserCardService";

function UserCardModal({ handleClose, cardType, userId }) {
    const isCreateMode = cardType === CardTypes.CREATE;

    return (
        <div className="modal oct_display-block modal-v2-root oct_auth-user-modal">
            <div className="modal fade oct_modal show modal-v2-overlay">
                <div className="modal-dialog modal-dialog-centered modal-v2-dialog oct_auth-user-modal-dialog" aria-modal="true">
                    <div className="modal-content modal-v2-shell oct_auth-user-modal-shell">
                        <div className="modal-v2-header oct_auth-user-modal-header">
                            <div className="modal-v2-header-top">
                                <div className="modal-v2-header-copy">
                                    <h2 className="modal-v2-heading oct_auth-user-modal-heading">
                                        {isCreateMode ? "Create User" : "Edit User"}
                                    </h2>
                                    <p className="modal-v2-subheading oct_auth-user-modal-subheading">
                                        {isCreateMode
                                            ? "Add a local or external user account with role-based access."
                                            : "Update the selected user profile, access role, and authentication settings."}
                                    </p>
                                </div>
                                <button type="button" className="close modal-v2-close" aria-label="Close" onClick={handleClose}>
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                        </div>

                        <CreateUserCard handleClose={handleClose} cardType={cardType} userId={userId} />
                    </div>
                </div>
            </div>
        </div>
    )

}


export default UserCardModal;
